import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { families: Array, loadedFamilies: Array };

  intervalId = null;
  allFontsLoaded = false;
  maxTries = 5;
  tries = 0;

  initialize() {
    if (this.familiesValue && this.familiesValue.length > 0) {
      this.loadCachedFonts();

      if (this.loadedFamiliesValue.length === this.familiesValue.length) {
        return;
      }

      this.fontLoadListener();

      if (!this.allFontsLoaded) {
        this.intervalId = setInterval(() => this.fontLoadListener(), 500);
      }
    }
  }

  loadCachedFonts() {
    const cachedFonts = JSON.parse(localStorage.getItem("cachedFonts") || "[]");
    this.loadedFamiliesValue = cachedFonts;
  }

  fontLoadedSuccess() {
    if (this.intervalId) {
      this.stopCheck();
    }

    this.allFontsLoaded = true;
  }

  fontLoadListener() {
    const fontFamilies = this.familiesValue;

    if (!fontFamilies || fontFamilies.length === 0) {
      this.stopCheck();
      return;
    }

    try {
      const loadedFonts = fontFamilies
        .filter((family) => !this.loadedFamiliesValue.includes(family))
        .reduce((acc, family) => {
          const hasLoaded = this.checkFont(family);

          if (hasLoaded) {
            acc.push(family);
          }

          return acc;
        }, []);

      // Use Set to ensure there are no duplicated definitions
      this.loadedFamiliesValue = [
        ...new Set([...this.loadedFamiliesValue, ...loadedFonts]),
      ];

      localStorage.setItem(
        "cachedFonts",
        JSON.stringify(this.loadedFamiliesValue)
      );

      if (fontFamilies.length === loadedFonts.length) {
        this.fontLoadedSuccess();
      }
    } catch (e) {
      console.error(e);
    }

    if (this.tries === this.maxTries) {
      this.stopCheck();
    }
  }

  checkFont(family) {
    try {
      const hasLoaded = document.fonts.check(`12px ${family}`);
      return hasLoaded;
    } catch (error) {
      console.info(`document.fonts API error: ${error}`);
    }

    return false;
  }

  stopCheck() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }
}
